/* eslint-disable jira/filename-case */
const PROJECT_FRAGMENT = `
fragment ProjectFragment on JiraProject {
  key
  projectId
  avatar {
    large
  }
  name
  projectType
  simplified
  favorite
  administerProject: action(type: EDIT_PROJECT_CONFIG) {
    canPerform
  }
  createIssues: action(type: CREATE_ISSUES) {
    canPerform
  }
  viewIssues: action(type: VIEW_ISSUES) {
    canPerform
  }
}
`;

export const QUERY: '\nquery JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {\n  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {\n    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {\n      ...ProjectFragment\n    }\n    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {\n      ...ProjectFragment\n    }\n  }\n}\n\nfragment ProjectFragment on JiraProject {\n  key\n  projectId\n  avatar {\n    large\n  }\n  name\n  projectType\n  simplified\n  favorite\n  administerProject: action(type: EDIT_PROJECT_CONFIG) {\n    canPerform\n  }\n  createIssues: action(type: CREATE_ISSUES) {\n    canPerform\n  }\n  viewIssues: action(type: VIEW_ISSUES) {\n    canPerform\n  }\n}\n\n' = `
query JiraBusinessProjectDetails($cloudId: ID!, $projectIdOrKey: String!, $usingProjectKey: Boolean!, $projectId: ID!) {
  jwmSidebar(cloudId: $cloudId, projectIdOrKey: $projectIdOrKey) {
    jiraProjectByKey(cloudId: $cloudId, key: $projectIdOrKey) @include(if: $usingProjectKey) {
      ...ProjectFragment
    }
    jiraProjectById(id: $projectId) @skip(if: $usingProjectKey) {
      ...ProjectFragment
    }
  }
}
${PROJECT_FRAGMENT}
`;
